import React from "react";

const SpecialInstructionsEditor = ({
  value,
  onChange,
  canEdit = false,
}) => {
  return (
    <div className="mt-4">
      <label htmlFor="instructions" className="tupdate">
        Special Instructions
      </label>

      <textarea
        className="form-control mt-2"
        id="instructions"
        name="specialInstructions"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Instructions"
        maxLength={400}
        rows={4}
        disabled={!canEdit}

      />
    </div>
  );
};

export default SpecialInstructionsEditor;

